import { environment } from 'app/config/environment';
import { createJSONStorage } from 'jotai/utils';
import localforage from 'localforage';

export const jsonDB = localforage.createInstance({
  name: environment.JSON_STORAGE_KEY,
  driver: [localforage.INDEXEDDB, localforage.LOCALSTORAGE],
});

export const makeJSONStorage = <T>() =>
  createJSONStorage<T>(() => ({
    async getItem(key) {
      try {
        return await jsonDB.getItem<string>(key);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return null;
      }
    },
    async setItem(key, value) {
      await jsonDB.setItem(key, value);
    },
    async removeItem(key) {
      await jsonDB.removeItem(key);
    },
  }));

export const jsonStorage = makeJSONStorage();
